import { create } from 'zustand'

type ModalType = 'wallet' | 'menu' | null

interface State {
  activeModal: ModalType
}

const initialState: State = {
  activeModal: null,
}

interface Action {
  openModal: (modal: ModalType) => void
  closeModal: () => void
  reset: () => void
}

export const useModalControlStore = create<State & Action>(set => ({
  ...initialState,
  openModal: modal => set({ activeModal: modal }),
  closeModal: () => set({ activeModal: null }),
  reset: () => set(initialState),
}))

export const getModalControlStore = useModalControlStore.getState
